// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Client = require("react-dom/client");
var JsxRuntime = require("react/jsx-runtime");
var Application$ReactHooksTemplate = require("./Application.res.js");

var content = document.querySelector("#content");

if (!(content == null)) {
  var root = Client.createRoot(content);
  root.render(JsxRuntime.jsx(Application$ReactHooksTemplate.make, {}));
}

/* content Not a pure module */
